import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Check } from 'lucide-react';
const programs = [{
  title: 'Little Dragons',
  age: 'Ages 4-6',
  description: 'Our Little Dragons program is designed specifically for preschool and kindergarten age children. We focus on developing listening skills, balance, coordination, and stranger awareness in a fun, high-energy environment.',
  benefits: ['Improved Focus', 'Better Coordination', 'Listening Skills', 'Stranger Awareness'],
  schedule: 'Mon/Wed 4:30 PM, Tue/Thu 5:00 PM',
  image: 'https://images.unsplash.com/photo-1555597673-b21d5c935865?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Youth Program',
  age: 'Ages 7-12',
  description: 'The Youth program builds a strong foundation in Taekwondo while emphasizing character development. Students learn goal setting, perseverance, and respect while getting a great workout and learning self-defense.',
  benefits: ['Self-Defense Skills', 'Confidence Building', 'Physical Fitness', 'Discipline & Respect'],
  schedule: 'Mon/Wed 5:15 PM, Tue/Thu 5:45 PM',
  image: 'https://images.unsplash.com/photo-1518619745898-93e765966dcd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Teen & Adult',
  age: 'Ages 13+',
  description: "It's never too late to start! Our Teen & Adult program offers a comprehensive workout that improves flexibility, strength, and endurance while teaching practical self-defense techniques.",
  benefits: ['Stress Relief', 'Weight Management', 'Practical Self-Defense', 'Community Support'],
  schedule: 'Mon/Wed 7:00 PM, Tue/Thu 7:30 PM',
  image: 'https://images.unsplash.com/photo-1595078475328-1ab05d0a6a0e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Family Classes',
  age: 'All Ages',
  description: 'Families that kick together, stick together! Our family classes allow parents and children to train side-by-side, sharing the journey to Black Belt and creating lasting memories.',
  benefits: ['Family Bonding', 'Shared Goals', 'Convenient Schedule', 'Mutual Support'],
  schedule: 'Fridays 5:30 PM, Saturdays 10:00 AM',
  image: 'https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
export function ProgramsPage() {
  return <main className="pt-20 pb-20 bg-gray-50" data-id="element-457">
      <div className="bg-primary text-white py-16 mb-12" data-id="element-458">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-459">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-460">Our Programs</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-461">
            Expert instruction for every age and skill level. Find the perfect
            class for you or your child.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12" data-id="element-462">
        {programs.map((program, index) => <Card key={program.title} className="overflow-hidden" data-id="element-463">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-464">
              <div className={`h-64 md:h-auto overflow-hidden ${index % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-465">
                <img src={program.image} alt={program.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-466" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-467">
                <div className="flex items-center mb-4" data-id="element-468">
                  <h2 className="text-3xl font-bold text-gray-900 mr-4" data-id="element-469">
                    {program.title}
                  </h2>
                  <span className="bg-blue-100 text-primary px-3 py-1 rounded-full text-sm font-semibold" data-id="element-470">
                    {program.age}
                  </span>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-471">
                  {program.description}
                </p>

                <div className="mb-8" data-id="element-472">
                  <h3 className="font-semibold text-gray-900 mb-3" data-id="element-473">
                    Program Benefits:
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-474">
                    {program.benefits.map(benefit => <div key={benefit} className="flex items-center text-gray-600 text-sm" data-id="element-475">
                        <Check className="w-4 h-4 text-green-500 mr-2" data-id="element-476" />
                        {benefit}
                      </div>)}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 mt-auto" data-id="element-477">
                  <Link to="/trial" data-id="element-478">
                    <Button data-id="element-479">Start 4-Week Trial</Button>
                  </Link>
                  <Link to="/contact" data-id="element-480">
                    <Button variant="outline" data-id="element-481">Contact Us</Button>
                  </Link>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </main>;
}